import axios, { InternalAxiosRequestConfig } from 'axios';
import { getUrlParam, isAppIntegrationRoute } from 'utils/embedParams';

const API_URL = process.env.REACT_APP_API_URL;

const chatService = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

chatService.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const conversationId = sessionStorage.getItem('conversationId');
        if (config.headers) {

            if (conversationId) {
                config.headers['x-conversation-id'] = conversationId;
            }

            // 2026-09-29 hotfix: tell Core which channel this actually is. The
            // widget already resolves this locally (used for its own analytics
            // tracking) but never sent it on the wire, so every Core-side channel
            // check had nothing real to read and silently defaulted to "web" —
            // including for genuine app traffic. Core reads this header
            // case-insensitively.
            config.headers['x-source'] = isAppIntegrationRoute() ? 'app' : 'web';

            if (isAppIntegrationRoute()) {
                const token = getUrlParam('x-exchange-token');
                if (token) config.headers['X-Exchange-Token'] = token;

                const provider = getUrlParam('x-exchange-provider');
                if (provider) config.headers['X-Exchange-Provider'] = provider;

                const signature = getUrlParam('x-exchange-signature');
                if (signature) config.headers['X-Exchange-Signature'] = signature;

                const timestamp = getUrlParam('x-exchange-timestamp');
                if (timestamp) config.headers['X-Exchange-Timestamp'] = timestamp;
            }

        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export { chatService };
